import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-document-layout',
  standalone: true,
  imports: [FooterComponent, RouterOutlet],
  templateUrl: './document-layout.component.html',
  styleUrl: './document-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentLayoutComponent {}
